<app-registrations (click)="cancelEditMode();$event.stopPropagation()"
  (keypress)="submitEdit($event);$event.stopPropagation()" [hideList]=true [determinantMapById]=determinantMapById>
  <div class="container-fluid px-md-5 mb-3">
    <determinant-builder-section
      *ngIf="(!registration.ownership || isFieldDisabled(registration.ownership) == false) && store.state.common.sections.active && store.state.common.sections.type === 'determinant'"
      (editCancel)="closeSection();" (editSave)="saveRegistrationDeterminant($event)" [regDeterminant]="regDeterminant"
      [serviceId]="serviceId">
    </determinant-builder-section>

    <institution-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
      (editCancel)="closeSection();" (formSubmit)="reloadInstitution();closeSection();" [ngStyle]="style" mwlResizable
      [enableGhostResize]="true" [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
      (resizeEnd)="onResizeEnd($event)" class="{{store.state.common.sections.type === 'institution' ? '': 'hidden'}}">
    </institution-edit>

    <unit-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
      (editCancel)="closeSection();" (formSubmit)="closeSection();" [ngStyle]="style" mwlResizable
      [enableGhostResize]="true" [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
      (resizeEnd)="onResizeEnd($event)" class="{{store.state.common.sections.type === 'unit' ? '': 'hidden'}}">
    </unit-edit>

    <requirement-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
      (editCancel)="closeSection();" (formSubmit)="closeSection();" [ngStyle]="style"
      [determinantMapById]="determinantMapById" mwlResizable [enableGhostResize]="true"
      [resizeEdges]="{bottom: false, right: false, top: false, left: true}" (resizeEnd)="onResizeEnd($event)"
      class="{{store.state.common.sections.type === 'requirement' ? '': 'hidden'}}">
    </requirement-edit>

    <result-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
      (editCancel)="closeSection()" (formSubmit)="closeSection()" [ngStyle]="style" mwlResizable
      [enableGhostResize]="true" [determinantMapById]="determinantMapById"
      [resizeEdges]="{bottom: false, right: false, top: false, left: true}" (resizeEnd)="onResizeEnd($event)"
      class="{{store.state.common.sections.type === 'result' ? '': 'hidden'}}">
    </result-edit>

    <cost-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
      (editCancel)="closeSection()" (formSubmit)="reloadCosts();closeSection()" [ngStyle]="style" mwlResizable
      [enableGhostResize]="true" [determinantMapById]="determinantMapById"
      [resizeEdges]="{bottom: false, right: false, top: false, left: true}" (resizeEnd)="onResizeEnd($event)"
      class="{{store.state.common.sections.type === 'cost' ? '': 'hidden'}}">
    </cost-edit>
    <!--
    <activity-condition-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
                            (editCancel)="closeSection()"
                             (formSubmit)="closeSection()"
                             [ngStyle]="style"
                             [determinantMapById]="determinantMapById"
                             mwlResizable
                             [enableGhostResize]="true"
                             [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
                             (resizeEnd)="onResizeEnd($event)"
                             class="row layer half-layer px-3 {{store.state.common.sections.type === 'condition' ? '': 'hidden'}}">
    </activity-condition-edit>
    <law-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
              (editCancel)="closeSection()"
              (formSubmit)="closeSection()"
              [ngStyle]="style"
              mwlResizable
              [enableGhostResize]="true"
              [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
              (resizeEnd)="onResizeEnd($event)"
              class="row layer half-layer px-3 {{store.state.common.sections.type === 'law' ? '': 'hidden'}}">
    </law-edit>

    <service-location-edit *ngIf="!registration.ownership || isFieldDisabled(registration.ownership) == false"
                          (editCancel)="closeSection()"
                           (formSubmit)="closeSection()"
                           [ngStyle]="style"
                           [determinantMapById]="determinantMapById"
                           mwlResizable
                           [enableGhostResize]="true"
                           [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
                           (resizeEnd)="onResizeEnd($event)"
                           class="row layer half-layer px-3 {{store.state.common.sections.type === 'location' ? '': 'hidden'}}">
    </service-location-edit>
  -->
    <!--div class="shadow"></div-->

    <div class="row">
      <div class="col-12">
        <div class="row fields-group faded py-2">
          <div class="col">
            <div class="d-flex">
              <span *ngIf="debugProps.debugMode" tooltip="{{'Registration has errors' | translate}}" container="body"
                placement="right" class="btn-circle-icon btn-circle-small btn-danger mr-2">
                <i class="far fa-bug"></i>
              </span>
              <business-key *ngIf="registration.businessKey" [businessKey]="registration.businessKey"
                [tooltipPosition]="'right'" [businessKeyTooltip]="'Registration business key' | translate"
                [extraClass]="'mr-5'"> </business-key>
              <span
                (click)="(!registration.ownership || !isFieldDisabled(registration.ownership)) ? toggleOperational() : false"
                class="toggle-small mr-4">
                <i
                  class="preview-icon {{registration.active ?  'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"></i>
                {{ 'Active' | translate }}
              </span>
              <ownership class="mr-4 reg-ownership" [ownership]="registration.ownership" [listIcons]="false" [title]="">
              </ownership>
              <span class="ml-auto">
                <span (click)="booleanValueChanged($event, disabled)" class="toggle-small mr-4">
                  <i
                    class="preview-icon {{registration.mandatoryChangeDisabled ?  'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"></i>
                  {{ 'determinant.change_disabled' | translate }}
                </span>
                <span (click)="booleanValueChanged($event, selectedByDefault)" class="toggle-small mr-4">
                  <i
                    class="preview-icon {{registration.mandatorySelectedDefault ?  'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"></i>
                  {{ 'reg.default_selected' | translate }}
                </span>
                <!--<user-level [page]="'RegistrationDetail'" [levelLabel]="'level.user'"></user-level>-->
                <tutorial-layer class="inpage-tutorial inline-tutorial-button" title="{{ registration.name }}"
                  [isClosed]="true" [editorData]="registration.tutorials.general" (saveTutorial)="saveTutorial($event)">
                </tutorial-layer>
              </span>
            </div>
          </div>
        </div>
        <div class="row fields-group">
          <div class="col-8">
            <div class="list-title d-flex w-100 pr-3">
              <span class="field-required mr-2 regname">{{ 'reg.name' | translate }}</span>
            </div>
            <form class="form-controller">
              <input required class="form-control" type="text" name="registrationName" [(ngModel)]="registration.name"
                #fname="ngModel" [rangeLength]="[2, 256]"
                [disabled]="registration.ownership && isFieldDisabled(registration.ownership)" width="80%"
                placeholder="{{'Type a name and press enter to submit' | translate}}" (click)="$event.stopPropagation()"
                (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event);$event.stopPropagation()" />
            </form>
            <p class="validation-error" *ngIf="fname?.errors?.required && (fname?.dirty && fname?.touched)">
              {{ 'form.validate.required' | translate }}
            </p>
            <p class="validation-error" *ngIf="fname?.errors?.rangeLength && (fname?.dirty && fname?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="fname?.errors?.rangeLength && (fname?.dirty && fname?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
          <div class="col-4">
            <div class="list-title">
              {{ 'reg.short_name' | translate }}
            </div>
            <form class="form-controller">
              <input required class="form-control" type="text" name="registrationShortName"
                [(ngModel)]="registration.shortName"
                [disabled]="registration.ownership && isFieldDisabled(registration.ownership)" width="100%"
                (click)="$event.stopPropagation()" (focus)="startEdit($event)"
                (focusout)="submitEditOnFocus($event);$event.stopPropagation()" />
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-xl-8 pr-xl-0">
        <registration-determinant class="row fields-group faded" [serviceId]="serviceId" [registration]="registration"
          (openDeterminantBuilderModal)="openDeterminantBuilderModal($event)" [determinantMapById]="determinantMapById"
          [debugErrors]="debugErrors" [disabled]="isFieldDisabled(registration.ownership)">
        </registration-determinant>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-xl-8 pr-xl-0">
        <registration-result [serviceId]="serviceId" [registration]="registration"
          [determinantMapById]="determinantMapById" [debugErrors]="debugErrors"
          [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
          (havePhysicalEvent)="onResultsChanged($event)"></registration-result>
        <registration-requirement [serviceId]="serviceId" [registration]="registration"
          [determinantMapById]="determinantMapById" [debugErrors]="debugErrors"
          [disabled]="registration.ownership && isFieldDisabled(registration.ownership)">
        </registration-requirement>
        <registration-cost [registration]="registration" [debugProps]="debugProps" [debugErrors]="debugErrors"
          [determinantMapById]="determinantMapById"
          [disabled]="registration.ownership && isFieldDisabled(registration.ownership)">
        </registration-cost>
        <!--
              <registration-condition class="row fields-group faded"
                                      [serviceId]="serviceId"
                                      [registration]="registration"
                                      [determinantMapById]="determinantMapById"
                                      [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
                                      *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.RegistrationDetail === 2">
              </registration-condition>
              -->
        <div class="row fields-group no-filter faded">
          <institution class="col" [serviceId]="serviceId" [isRequired]=true
            [registrationInstitution]="registrationInstitution" [registrationUnitsLength]="registrationUnitsLength"
            [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
            (registrationInstitutionsLength)="updateRegistrationInstitutionsLength($event);"
            [registration]="registration"></institution>
          <institution-unit class="col" *ngIf="!!registrationInstitution?.id" [serviceId]="serviceId"
            [registration]="registration" [registrationInstitution]="registrationInstitution"
            [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
            (registrationUnitsLength)="updateRegistrationUnitsLength($event);"></institution-unit>
        </div>
        <!--
              <registration-law class="row fields-group faded"
                                [serviceId]="serviceId"
                                [registration]="registration"
                                [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
                                *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.RegistrationDetail === 2">
              </registration-law>
              <registration-location class="row fields-group faded"
                                [serviceId]="serviceId"
                                [registration]="registration"
                                [disabled]="registration.ownership && isFieldDisabled(registration.ownership)"
                                *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.RegistrationDetail === 2 && havePhysicalResults">
              </registration-location>
              -->
      </div>
    </div>
  </div>
</app-registrations>